import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { MappedSwitch } from "../../../../ui/components/MappedSwitch";

const addressMap = {
  chem_address_1: "chem_contact_address_1",
  chem_address_2: "chem_contact_address_2",
  chem_suburb: "chem_contact_suburb",
  chem_state: "chem_contact_state",
  chem_postcode: "chem_contact_postcode",
};

export const FillAddress = () => {
  const { values, setFieldValue } = useFormikContext();

  const calculateValue = (fieldName, value) => (value ? values[fieldName] : "");

  useEffect(() => {
    Object.keys(addressMap).forEach((fieldName) => {
      setFieldValue(fieldName, calculateValue(addressMap[fieldName], values.as_contact_address));
    });
    // eslint-disable-next-line
  }, [values.as_contact_address]);

  return (
    <div className="d-flex align-items-center justify-content-end mt-3">
      <p className="mr-2 mt-3">Use Contact Address as Chemical Storage Location Information</p>
      <MappedSwitch name="as_contact_address" checked={values.as_contact_address} />
    </div>
  );
};
